<app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>

<div class="container">
  <div style="vertical-align: middle; padding-bottom: 10px; text-align: center">
    <h1 style="font-size: 22px">{{type.toUpperCase()}} di {{patient.name}} {{patient.surname}} da compilare:</h1>
    <ng-container *ngIf="pendings && pendings.length > 0; else noPendings">
         <h3>{{pendings.length}} rimanenti</h3>
    </ng-container>
    <ng-template #noPendings>
      <h3>0 rimanenti</h3>
    </ng-template>
  </div>
  <mat-card class="mat-elevation-z10">
    <ng-container *ngIf="pendings && pendings.length > 0; else noPending">
      <mat-list >
        <mat-list-item *ngFor="let p of pendings">
          <mat-icon mat-list-icon>folder</mat-icon>
          <div mat-line style="cursor: pointer" (click)="goTo(p)">
            {{p.id.split('-')[0]}} - {{p.type}}
          </div>
        </mat-list-item>
      </mat-list>
    </ng-container>
    <ng-template #noPending>
      <h3 style="text-align: center; margin: auto">Nessun questionario in sospeso.</h3>
    </ng-template>
    <mat-card-content fxLayout="column">

    </mat-card-content>
  </mat-card>
</div>


